import React from 'react';
import loadable from '@loadable/component';

import { IMAGE_STYLE_FIXED, STANDARD_STYLE } from '@eb/eds-media-card-content';

const IMAGE_STYLE_SQUARE = 'square';
const MINI_STYLE = 'mini';

const SearchEventCard = loadable(() => import('./SearchEventCard'));

export default class SearchEventCardStyleSwitcher extends React.PureComponent {
    render() {
        return (
            <div>
                <div className="search-event-card-rectangle-image">
                    <SearchEventCard
                        {...this.props}
                        style={STANDARD_STYLE}
                        imageStyle={IMAGE_STYLE_FIXED}
                    />
                </div>
                <div className="search-event-card-square-image">
                    <SearchEventCard
                        {...this.props}
                        style={MINI_STYLE}
                        imageStyle={IMAGE_STYLE_SQUARE}
                    />
                </div>
            </div>
        );
    }
}
